// src/apiBase.js
// Single source of truth for API base URL.
// Works for:
// - Local dev (localhost:3000 -> backend localhost:5002)
// - Cloudflare/Railway (same-origin /api requests)
// - Future deployment (no hardcoded localhost in modules)

export function getApiBase() {
  // Optional override (useful later for staging/prod):
  const env = (process.env.REACT_APP_API_BASE || '').trim();
  if (env) return env.replace(/\/+$/, '');

  const host = window.location.hostname;

  // Local dev: React runs on :3000, backend on :5002
  if (host === 'localhost' || host === '127.0.0.1') return 'http://localhost:5002';

  // Anything else (Cloudflare tunnel, Railway, custom domain):
  // Use same origin and hit /api/* directly.
  return window.location.origin;
}

// Public links base (customer-facing).
// In dev, it must point to backend so /public/* works.
// In deployed same-origin setups, window.location.origin is correct.
export function getPublicBase() {
  const apiBase = getApiBase();

  // If apiBase is localhost backend, use it directly.
  // Otherwise, public pages are assumed same-origin.
  if (apiBase.includes('localhost:5002') || apiBase.includes('127.0.0.1:5002')) {
    return apiBase;
  }

  return window.location.origin;
}